import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
// Registreert de globale error- en unhandledrejection-listeners.
import "./functions/api/guardian";
import { installApiErrorReporting } from "./functions/api/reportApiErrors";
import store, { rrfProps } from "./redux/store";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { ThemeProvider } from "./data/hooks/theme/useTheme";

installApiErrorReporting();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ReactReduxFirebaseProvider>
  </Provider>,
);
